// extracted by mini-css-extract-plugin
export default {"amountMeta":"TransactionTable_amountMeta__FzJqo"};